export default {"src":"/_next/static/media/NotificationFilledIcon.db22dff1.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};